import React from 'react';
import { UCAModule, CommonModule } from "uca-react-containers-library";

const AddressPrefComponent = () => {
    const { saveRouteData } = CommonModule.useRoute();
    const { appData } = CommonModule.useApp();
    const heading = !appData.isBusinessBanner ? 'Addresses' : 'Address Preferences';

    React.useEffect(() => {
        saveRouteData({ 'currentPage': heading });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderAddressPreferences = () => {
        return <UCAModule.AddressPreferencesV3 />;
    };

    return (
        <CommonModule.ViewportProvider>
            <div class="col-lg-3 col-xl-3">
                <UCAModule.LeftNavigation></UCAModule.LeftNavigation>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                {renderAddressPreferences()}
            </div>
        </CommonModule.ViewportProvider>
    );
};

export default AddressPrefComponent;